import React from 'react';
import styles from './WhatsAppButton.module.scss';
import { Images } from '../../utils/Images';
const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/8801317801712"
      target="_blank"
      rel="noopener noreferrer"
      className={styles.whatsappButton}
    >
      {/* <span>Need Help? <strong>Chat with us</strong></span> */}
      <img src={Images.WhatsApp} alt="WhatsApp" />
    </a>
  );
};

export default WhatsAppButton;
